<template>
  <div class="checkout__section card">
    <h4 class="checkout__section-tit">
      Pagamento
    </h4>

    <div class="payment">
      <div v-show="Number(cardsNumber) > 0">
        <h5 class="payment__tit">
          Cartões cadastrados
        </h5>

        <credit-card-list
          v-model="savedCard"
          @cards-number="updateCardsNumber"
        />

        <hr class="separator" />
      </div>

      <div>
        <h5
          v-show="ui.showForm || Number(cardsNumber) === 0"
          class="payment__tit"
        >
          Cadastrar novo cartão
        </h5>

        <credit-card-new
          v-show="ui.showForm || Number(cardsNumber) === 0"
          v-model="newCard"
        />

        <div
          v-show="ui.showForm || Number(cardsNumber) > 0"
          :class="{ 'pointer-events-none': ui.isLoading }"
          class="mt-1 flex flex-row items-center justify-start"
        >
          <label class="!my-0 !py-0 normal-case text-sm form-radio">
            <input
              v-model="ui.isNew"
              type="radio"
              :value="1"
            >

            <i class="form-icon" />

            <span class="mt-0 block flex items-center leading-relaxed">
              Continuar com novo cartão
            </span>
          </label>
        </div>

        <div
          v-show="Number(cardsNumber) > 0"
          :class="{ 'pointer-events-none': ui.isLoading }"
          class="mt-1 flex flex-row items-center justify-start"
        >
          <button
            v-show="!ui.showForm && Number(cardsNumber) > 0"
            class="btn btn-blue mt-0 block flex items-center leading-relaxed"
            @click.prevent="showNewForm"
          >
            Cadastrar novo cartão
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import creditCardNew from './creditCardNew.vue'
import creditCardList from './creditCardList.vue'

export default {
  name: 'CheckoutCreditCard',

  props: {
    card: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  model: {
    prop: 'card',
    event: 'change'
  },

  components: {
    creditCardNew,
    creditCardList
  },

  data () {
    return {
      savedCard: {},
      newCard: {},
      cardsNumber: null,
      ui: {
        isNew: 0,
        showForm: false
      }
    }
  },

  watch: {
    'ui.isNew': {
      deep: false,
      immediate: false,
      handler (v) {
        if (v === 1) {
          this.savedCard = {}
          this.$emit('change', this.newCard)
        }
      }
    },

    newCard: {
      deep: true,
      immediate: false,
      handler (v) {
        if (this.ui.isNew === 1) {
          this.$emit('change', this.newCard)
        }
      }
    },

    savedCard: {
      deep: true,
      immediate: false,
      handler (v = {}) {
        if (Object.keys(v).length > 0) {
          this.$set(this.ui, 'isNew', 0)
          this.$emit('change', this.savedCard)
        }
      }
    },

    cardsNumber: {
      deep: false,
      immediate: false,
      handler (v) {
        if (Number(v) === 0) {
          this.$set(this.ui, 'isNew', 1)
        }
      }
    }
  },

  methods: {
    updateCardsNumber (n) {
      this.cardsNumber = n
    },

    showNewForm () {
      this.ui.isNew = 1
      this.ui.showForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '$vars';

.checkout {
  &__section {
    @apply p-3 mb-3;
    background: #f4f4f4;

    &-tit {
      color: $color-green;
      font-family: $font1;
      font-size: 1rem;
    }
  }
}

.separator {
  background: #E0E0E0;
  border: 0;
  border-top: 1px solid #fff;
  height: 1px;
  margin: 1rem auto;
  width: 100%;
}

.payment {
  &__tit {
    color: #444444;
    font-family: $font1;
    font-size: 0.95rem;
  }
}
</style>
